import { render, staticRenderFns } from "./ProjectTasks.vue?vue&type=template&id=28d08c6c&scoped=true&"
import script from "./ProjectTasks.vue?vue&type=script&lang=js&"
export * from "./ProjectTasks.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTasks.vue?vue&type=style&index=0&id=28d08c6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d08c6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VDialog,VForm,VIcon,VSpacer,VTextarea,VTooltip})
